import { RowModule } from 'ui/components/3-organisms/RowModule';
import { ModuleFeature } from 'features/Modules';

const DOC_TYPE_TEXT = 'centeredText';
const DOC_TYPE_IMAGE = 'articleMedia';

const getMobileOrder = (modules: any[] = []): number[] =>
  modules.map((_, index) => {
    const isSwappedPair =
      modules[index]?.content?.documentType === DOC_TYPE_TEXT &&
      modules[index + 1]?.content?.documentType === DOC_TYPE_IMAGE;
    const isSwappedPairNext =
      modules[index - 1]?.content?.documentType === DOC_TYPE_TEXT &&
      modules[index]?.content?.documentType === DOC_TYPE_IMAGE;

    return isSwappedPair ? index + 1 : isSwappedPairNext ? index - 1 : index;
  });

export const RowModuleFeature: React.FC<Content.RowModule> = ({ content, settings }) => {
    const { rowContent, backgroundColor, firstModuleWidth } = content?.properties ?? {};

    return (
        <RowModule 
            backgroundColor={backgroundColor}
            firstModuleWidth={firstModuleWidth}
            mobileOrder={getMobileOrder(rowContent)}
            {...settings?.properties} 
        >
            {rowContent?.map((contentModule, index) => (
                <ModuleFeature key={index} contentModule={contentModule} />
            ))}
        </RowModule>
    );
    };